import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/ayb.webp';
import screenshot_target from '../../../images/letterfunnel/justinoud.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Justin Oud"
      firstname="Justin"
      companyname="AYB"
      competition="Programic en RECOGNIZE"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/justinoud.js